export const formatCurrency = (number = 0, hideDecimal = false) => {
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: hideDecimal ? 0 : 2,
    maximumFractionDigits: hideDecimal ? 0 : 2
  }).format(number)
}

export function formatDoubleDigit(val) {
  return val < 10 ? '0' + val : '' + val
}
